
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gMEASjm7UIBzPDE9r8hjUBueCL62wMkEX871aI9F_453IYMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3GMWIafoADzhuKkp_45rnmieVcwRr1pEf3YJ_45DYGZxdWYMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search_YeLrAX5nSF1tEIjuoRKuGBTOvLpYDuq0v0j3lxsqk8Meta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexKa5JdL79p158Du0jrQuxdZ8vf6QGS0dveMxWIeDe3swMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93f7fZeXyvvbHkqlKRa792Z6KRXLMP6hlXkLnmkUrpfu8Meta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexsMJqlPvIO0dBFQfYwez9ier1s9e1bskhxwrfNJEai4MMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93lv6_45QfpH9pUvsQyDrrdnUNzTdbZEaNtnMscohRmp58kMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indextYwm5n8Taxaz6ZORI6pS1sjsXMZpTXPeSiXRNX1_C9YMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93lrF9dM_yIVOhuxAUaujVRyFXQDimpf03TW_45F_45Y_457WzwMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexKfx2j5BvSDSr_45zRkR7pSchDJVMAs1T6n5ME23HcIEN0Meta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2SbaR26pjX0vlw6_45yb6BKIE8PNXRgyGA95TeXKdTCFcMeta } from "/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexsMJqlPvIO0dBFQfYwez9ier1s9e1bskhxwrfNJEai4MMeta || {},
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indextYwm5n8Taxaz6ZORI6pS1sjsXMZpTXPeSiXRNX1_C9YMeta || {},
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexKfx2j5BvSDSr_45zRkR7pSchDJVMAs1T6n5ME23HcIEN0Meta || {},
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2SbaR26pjX0vlw6_45yb6BKIE8PNXRgyGA95TeXKdTCFcMeta || {},
    component: () => import("/codebuild/output/src2148397598/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]